import React, { useEffect, useState } from 'react';
import { saveHolidays } from '../../../Services/MasterdataService';
import moment from 'moment';
import {
  Box,
  Button,
  Stack,
  TextField,
  Grid,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
} from '@mui/material';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../../../constants';
import DisabledDatePicker from '../../../../components/DisabledDatePicker';
import './AddHoliday.css';
import LoadingButton from '@mui/lab/LoadingButton';
import { ERROR_KEY } from '../../../../constants';
import { getHolidays } from '../../../Services/MasterdataService';
const AddHoliday = (props) => {
  const {
    holidayTitle,
    setTitle,
    date,
    setDate,
    loadData,
    setOpen,
    officeLocation,
    setSelectedLocationId,
    selectedLocationId,
    holidaysList,
    getHolidays,
  } = props;
  const [holidays, setHolidays] = useState(holidaysList);
  const dispatch = useDispatch();
  const [IsError, setIsError] = React.useState(false);
  const [IsTextError, setIsTextError] = React.useState(false);
  const [loadingApiCall, setLoadingApiCall] = React.useState(false);
  const currentYear = new Date().getFullYear();
  const nextYear = currentYear + 1;
  const [locationId, setLocationId] = useState(selectedLocationId);
  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };
  const OnCancel = () => {
    setOpen(false);
    setTitle('');
    setDate(null);
  };
  const handleInputChange = (event) => {
    const { value } = event.target;
    setTitle(value);
    setIsTextError(false);
  };

  const onDatePicketInputChange = (value) => {
    if (value !== null) {
      {
        if (value.$y === currentYear || value.$y === nextYear) {
          setDate(value);
          setIsError(false);
        } else {
          setIsError(true);
        }
      }
    }
  };

  const onAddClick = async () => {
    if (date !== null && holidayTitle.trim() !== '') {
      if (!IsError) {
        setLoadingApiCall(true);
        const holiday = {
          date: moment(new Date(date)).format('YYYY-MM-DD'),
          occasion: holidayTitle,
          tenantId: 'beehyv',
        };
        const response = await saveHolidays(holiday, locationId);
        setLoadingApiCall(false);
        if (response.isError === false) {
          loadData(locationId);
          setSelectedLocationId(locationId);
          setTitle('');
          setDate(null);
          setOpen(false);
        }
        dipatchNotification(response.type, response.message);
      } else {
        dipatchNotification(
          'error',
          `The date should be set between ${currentYear} and ${nextYear}`,
        );
      }
    }
    if (holidayTitle.trim() === '') {
      setIsTextError(true);
      if (date === null) {
        setIsError(true);
        return;
      }
      return;
    }
    if (date === null) {
      setIsError(true);
      return;
    }
  };

  const groupDataByYear = (data) => {
    const groupedData = [];

    data.forEach((item) => {
      const year = new Date(item.date).getFullYear();
      const existingYearIndex = groupedData.findIndex(
        (group) => group.year === year,
      );

      if (existingYearIndex !== -1) {
        groupedData[existingYearIndex].data.push(item);
      } else {
        groupedData.push({ year, data: [item] });
      }
    });

    return groupedData;
  };

  const handleSelect = async (value) => {
    setLocationId(value);
    const response = await getHolidays(value);
    if (response.isError === false) {
      if (response.data && response.data.length > 0) {
        setHolidays(groupDataByYear(response.data));
      } else {
        setHolidays([]);
      }
    }
    setDate(null);
  };

  return (
    <Box
      sx={{ display: 'flex', flexDirection: 'row', boxSizing: 'border-box' }}
    >
      <Box sx={{ width: '50%', margin: 2, marginRight: 1 }}>
        <TextField
          name="holidayTitle"
          value={holidayTitle}
          error={IsTextError}
          onChange={handleInputChange}
          required
          id="standard-required"
          label="Holiday Title"
          multiline
          rows={1}
        />
        <FormControl
          sx={{
            width: '100%',
            mt: 3,
          }}
        >
          <InputLabel id="demo-simple-select-helper-label">
            Office-Location
          </InputLabel>
          <Select
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              width: '100%',
            }}
            labelId="demo-simple-select-helper-label"
            id="standard-required"
            name="Office Location"
            value={locationId}
            label="Office Location"
            onChange={(event) => handleSelect(event.target.value)}
          >
            {Array.isArray(officeLocation) &&
              officeLocation.map((location) => (
                <MenuItem id={location.id} value={location.id}>
                  {location.locationName}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
      <Box sx={{ width: '50%', margin: 2, marginLeft: 1 }}>
        <DisabledDatePicker
          onDatePicketInputChange={onDatePicketInputChange}
          holidays={holidays}
          value={date}
          error={IsError}
        />
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            mt: 4,
          }}
        >
          <Button variant="outlined" color={ERROR_KEY} onClick={OnCancel}>
            Cancel
          </Button>
          <LoadingButton
            loading={loadingApiCall}
            type="submit"
            variant="contained"
            onClick={() => onAddClick()}
          >
            {loadingApiCall ? 'loading...' : 'Add Holiday'}
          </LoadingButton>
        </Box>
      </Box>
    </Box>
  );
};

export default AddHoliday;
